const init = () => {
    initMegaMenu();
    videoControlsInit();
    globalClickListener();
    setupMobileAccordions();
    window.addEventListener('resize', debounce(setupMobileAccordions, 250));
    setupAccordionListeners();
    a11yFixes();
};

const a11yFixes = () => {
    const links = document.querySelectorAll('a[target="_blank"]:not([aria-label*="new window"])');
    if (links) {
        links.forEach((link, ind) => {
            link.setAttribute('aria-label', `Open ${encodeURIComponent(link.textContent.trim())} in new window`);
        });
    }
};

function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      func.apply(context, args);
    }, wait);
  };
}

function setupMobileAccordions() {
  const isDesktop = window.innerWidth >= 750; // Using innerWidth instead of screen.width
  
  const accordions = document.querySelectorAll('.mobile-accordion');
  accordions.forEach(el => {
    if (isDesktop) {
      // Force open on desktop
      el.setAttribute('open', '');
    } else {
      // Initial state on mobile - closed
      // Don't remove 'open' attribute here to allow for user interaction
      // This prevents the accordion from closing when switching to mobile
    }
  });
}

function setupAccordionListeners() {
  const summaries = document.querySelectorAll('.mobile-accordion summary');
  
  summaries.forEach(summary => {
    summary.addEventListener('click', function(event) {
      const isMobile = window.innerWidth < 750;
      const accordion = this.parentElement;
      
      if (!isMobile) {
        // Prevent toggling on desktop
        event.preventDefault();
        return;
      }
      
      // For Safari/Firefox fix: manually toggle the open state
      // This helps ensure the toggle behavior works consistently across browsers
      const isOpen = accordion.hasAttribute('open');
      
      // Important: setTimeout helps with event flow in Safari
      setTimeout(() => {
        if (isOpen) {
          accordion.removeAttribute('open');
        } else {
          accordion.setAttribute('open', '');
        }
        
        // Force repaint for Safari
        accordion.style.display = 'none';
        accordion.offsetHeight; // Trigger reflow
        accordion.style.display = '';
      }, 0);
    });
  });
}

const globalClickListener = () => {
    document.body.addEventListener('click', function (e) {
        const target = e.target;
        if (window.screen.width < 990) {
            if (target.classList.contains('footer-block__heading')) {
                const dropdownEl = target.closest('.footer-block-content');
                const isOpen = dropdownEl.classList.contains('open');
                if (isOpen) {
                    dropdownEl.classList.remove('open');
                } else {
                    dropdownEl.classList.add('open');
                }
            }
        }
        readMore(target, e);
    });
};

const readMore = (target, e) => {
    if (target.classList.contains('read-more')) {
        e.preventDefault();
        target.closest('.read-more-container').classList.add('expanded');
    }
    if (target.classList.contains('read-more-btn')) {
        e.preventDefault();
        const readMoreContainer = target.closest('.read-more-container');
        if (readMoreContainer.classList.contains('expanded')) {
            readMoreContainer.classList.remove('expanded');
        }
        else {
            readMoreContainer.classList.add('expanded');
        }
    }
};

const videoControlsInit = () => {
    let isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const videoToggles = [...document.querySelectorAll('.utility-btn')];
    if (videoToggles.length !== 0) {
        videoToggles.forEach((videoToggle) => {
            const video = videoToggle.parentElement.querySelector('video');
            if (!!video) {
                videoToggle.addEventListener('click', function (e) {
                    e.preventDefault();
                    const videoEl = this.parentElement.querySelector('video');
                    const videoPlay = videoEl.paused || videoEl.ended;
                    videoEl.controls = 0;
                    if (videoPlay) {
                        videoEl.play();
                        videoEl.classList.add('keep-playing');
                        videoEl.parentElement.classList.add('playing');
                        videoToggle.setAttribute('aria-label', 'pause video');
                        videoToggle.classList.add('active');
                    } else {
                        videoEl.pause();
                        videoEl.classList.remove('keep-playing');
                        videoEl.parentElement.classList.remove('playing');
                        videoToggle.setAttribute('aria-label', 'play video');
                        videoToggle.classList.remove('active');
                    }
                });
                video.classList.add('keep-playing');
                if (isMobileDevice) {
                    video.pause();
                    video.classList.remove('keep-playing');
                    video.parentElement.classList.remove('playing');
                    videoToggle.setAttribute('aria-label', 'play video');
                    videoToggle.classList.remove('active');
                }
            }
        });
        const videos = document.querySelectorAll('video');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const videoEl = entry.target;
                const isPlay = videoEl.paused && videoEl.classList.contains('keep-playing');
                const isPause = entry.intersectionRatio === 0 && !videoEl.paused;
                if (isPause) {
                    videoEl.pause();
                    videoEl.parentElement.classList.remove('playing');
                    let toggle = videoEl.parentElement.querySelector('.utility-btn');
                    toggle.setAttribute('aria-label', 'play video');
                    toggle.classList.remove('active');
                } else if (isPlay) {
                    videoEl.play();
                    videoEl.parentElement.classList.add('playing');
                    let toggle = videoEl.parentElement.querySelector('.utility-btn');
                    toggle.setAttribute('aria-label', 'pause video');
                    toggle.classList.add('active');
                }
            });
        });
        videos.forEach((video) => {
            observer.observe(video);
        });
    }
};

const setupMegaMenuAccordion = () => {
  const accordionToggles = document.querySelectorAll('.mega-menu__accordion-toggle');
  const parentLinks = document.querySelectorAll('.mega-menu__link--parent');
  const parentWrappers = document.querySelectorAll('.mega-menu__parent-wrapper');
  const nestedToggles = document.querySelectorAll('.mega-menu__link--toggle');

  const setNestedToggleLabel = (toggle) => {
    const menuName = toggle.querySelector('.mega-menu__link--text-container')?.textContent.trim() || 'submenu';
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-label', `${isExpanded ? 'Collapse' : 'Expand'} ${menuName}`);
  };

  const closeNestedToggle = (toggle, animate = true) => {
    const submenuId = toggle.getAttribute('aria-controls');
    const submenu = submenuId ? document.getElementById(submenuId) : null;
    const item = toggle.closest('.mega-menu__item--has-children');

    if (toggle.getAttribute('aria-expanded') !== 'true') return;

    toggle.setAttribute('aria-expanded', 'false');
    setNestedToggleLabel(toggle);
    item?.classList.remove('is-open');

    if (!submenu) return;

    if (!animate) {
      submenu.hidden = true;
      submenu.style.removeProperty('max-height');
      submenu.style.removeProperty('overflow');
      return;
    }

    submenu.style.overflow = 'hidden';
    submenu.style.maxHeight = `${submenu.scrollHeight}px`;
    void submenu.offsetHeight;
    submenu.style.maxHeight = '0px';

    const onEnd = (event) => {
      if (event.propertyName !== 'max-height') return;
      if (toggle.getAttribute('aria-expanded') === 'true') return;

      submenu.hidden = true;
      submenu.style.removeProperty('max-height');
      submenu.style.removeProperty('overflow');
      submenu.removeEventListener('transitionend', onEnd);
    };

    submenu.addEventListener('transitionend', onEnd);
  };

  const toggleNestedSubmenu = (toggle) => {
    const submenuId = toggle.getAttribute('aria-controls');
    const submenu = submenuId ? document.getElementById(submenuId) : null;
    const item = toggle.closest('.mega-menu__item--has-children');
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    const section = toggle.closest('.mega-menu__section');
    section?.querySelectorAll('.mega-menu__link--toggle').forEach((otherToggle) => {
      if (otherToggle !== toggle) closeNestedToggle(otherToggle);
    });

    if (isExpanded) {
      closeNestedToggle(toggle);
      return;
    }

    toggle.setAttribute('aria-expanded', 'true');
    setNestedToggleLabel(toggle);
    item?.classList.add('is-open');

    if (submenu) {
      submenu.hidden = false;
      submenu.style.maxHeight = 'none';
      const targetHeight = submenu.scrollHeight;
      submenu.style.maxHeight = '0px';
      void submenu.offsetHeight;
      submenu.style.maxHeight = `${Math.max(targetHeight, 1)}px`;

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        if (toggle.getAttribute('aria-expanded') === 'true') {
          submenu.style.maxHeight = 'none';
        }
        submenu.removeEventListener('transitionend', onEnd);
      };
      submenu.addEventListener('transitionend', onEnd);
    }
  };

  const setInitialAriaLabels = () => {
    accordionToggles.forEach(toggle => {
      if (toggle) {
        const parentLink = toggle.closest('.mega-menu__parent-wrapper')?.querySelector('.mega-menu__link--parent');
        const menuName = parentLink ? parentLink.textContent.trim() : 'menu';
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        
        toggle.setAttribute('aria-label', `${isExpanded ? 'Close' : 'Open'} ${menuName} menu`);
      }
    });

    nestedToggles.forEach((toggle) => {
      if (toggle) setNestedToggleLabel(toggle);
    });
  };
  
  const animateSubmenuOpen = (submenu) => {
    submenu.style.display = 'block';
    submenu.style.overflow = 'hidden';
    submenu.style.maxHeight = 'none';
    const targetHeight = submenu.scrollHeight;
    submenu.style.maxHeight = '0px';
    void submenu.offsetHeight;
    submenu.style.maxHeight = `${Math.max(targetHeight, 1)}px`;

    const onEnd = (event) => {
      if (event.propertyName !== 'max-height') return;
      submenu.style.maxHeight = 'none';
      submenu.style.overflow = 'visible';
      submenu.removeEventListener('transitionend', onEnd);
    };
    submenu.addEventListener('transitionend', onEnd);
  };

  const animateSubmenuClose = (submenu, section) => {
    submenu.style.overflow = 'hidden';
    submenu.style.maxHeight = `${submenu.scrollHeight || 0}px`;
    void submenu.offsetHeight;
    submenu.style.maxHeight = '0px';

    window.setTimeout(() => {
      if (section && section.classList.contains('menu-open')) return;
      submenu.style.display = 'none';
      submenu.style.removeProperty('max-height');
      submenu.style.removeProperty('overflow');
    }, 300);
  };

  const toggleAccordion = (toggle) => {
    const submenuId = toggle.getAttribute('aria-controls');
    const submenu = document.getElementById(submenuId);
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const isMobile = window.innerWidth <= 990;
    
    const parentLink = toggle.closest('.mega-menu__parent-wrapper')?.querySelector('.mega-menu__link--parent');
    const menuName = parentLink ? parentLink.textContent.trim() : 'menu';
    
    // Close all other open accordions first
    const allSections = document.querySelectorAll('.mega-menu__section');
    allSections.forEach(section => {
      const otherToggle = section.querySelector('.mega-menu__accordion-toggle');
      const otherSubmenuId = otherToggle?.getAttribute('aria-controls');
      const otherSubmenu = otherSubmenuId ? document.getElementById(otherSubmenuId) : null;
      
      if (otherToggle && otherSubmenu && otherToggle !== toggle) {
        otherToggle.setAttribute('aria-expanded', 'false');
        
        const otherParentLink = otherToggle.closest('.mega-menu__parent-wrapper')?.querySelector('.mega-menu__link--parent');
        const otherMenuName = otherParentLink ? otherParentLink.textContent.trim() : 'menu';
        otherToggle.setAttribute('aria-label', `Open ${otherMenuName} menu`);
        
        section.classList.remove('menu-open');
        
        if (isMobile) {
          animateSubmenuClose(otherSubmenu, section);
        } else {
          otherSubmenu.style.display = 'none';
        }
      }
    });
    
    // Toggle current accordion
    toggle.setAttribute('aria-expanded', !isExpanded);
    toggle.setAttribute('aria-label', `${!isExpanded ? 'Close' : 'Open'} ${menuName} menu`);
    
    if (submenu) {
      const section = toggle.closest('.mega-menu__section');

      if (isExpanded) {
        section.classList.remove('menu-open');
        
        if (isMobile) {
          animateSubmenuClose(submenu, section);
        } else {
          submenu.style.display = 'none';
        }
      } else {
        section.classList.add('menu-open');

        if (isMobile) {
          animateSubmenuOpen(submenu);
        } else {
          submenu.style.display = 'block';
          submenu.style.removeProperty('max-height');
        }
      }
    }
  };
  
  // Handle parent links differently based on device
  const updateParentLinks = () => {
    const isMobile = window.innerWidth < 990;
    
    parentLinks.forEach(link => {
      if (link && link.getAttribute('href') === '#') {
        if (isMobile) {
          link.style.pointerEvents = 'auto';
          link.style.cursor = 'pointer';
        } else {
          link.style.pointerEvents = 'none';
          link.style.cursor = 'default';
        }
      }
    });
  };
  
  setInitialAriaLabels();
  
  accordionToggles.forEach(toggle => {
    if (toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleAccordion(this);
      });
    }
  });

  nestedToggles.forEach((toggle) => {
    if (!toggle || toggle.getAttribute('data-nested-bound') === 'true') return;
    toggle.setAttribute('data-nested-bound', 'true');
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleNestedSubmenu(this);
    });
  });
  
  const megaMenuContent = document.getElementById('MegaMenu-Content-Main');
  const alreadyInitialized = megaMenuContent && megaMenuContent.getAttribute('data-wrappers-initialized') === 'true';
  
  const setupParentWrappers = () => {
    const isMobile = window.innerWidth < 990;
    

    if (!alreadyInitialized) {
      parentWrappers.forEach(wrapper => {
        if (wrapper && wrapper.parentNode) {
          const newWrapper = wrapper.cloneNode(true);
          wrapper.parentNode.replaceChild(newWrapper, wrapper);
        }
      });
      
      if (megaMenuContent) {
        megaMenuContent.setAttribute('data-wrappers-initialized', 'true');
      }
    }
    
    const currentParentWrappers = document.querySelectorAll('.mega-menu__parent-wrapper');
    
    currentParentWrappers.forEach(wrapper => {
      if (wrapper && wrapper.parentNode) {
        const wrapperClone = wrapper.cloneNode(true);
        wrapper.parentNode.replaceChild(wrapperClone, wrapper);
        
        if (isMobile) {
          wrapperClone.addEventListener('click', function(e) {
            const link = this.querySelector('.mega-menu__link--parent');
            if (link && link.getAttribute('href') !== '#') {
              return; 
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            const toggle = this.querySelector('.mega-menu__accordion-toggle');
            if (toggle) {
              toggleAccordion(toggle);
            }
          });
        }
      }
    });
    
    const newToggles = document.querySelectorAll('.mega-menu__accordion-toggle');
    newToggles.forEach(toggle => {
      if (toggle && toggle.parentNode) {
        const parentLink = toggle.closest('.mega-menu__parent-wrapper')?.querySelector('.mega-menu__link--parent');
        const menuName = parentLink ? parentLink.textContent.trim() : 'menu';
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        
        toggle.setAttribute('aria-label', `${isExpanded ? 'Close' : 'Open'} ${menuName} menu`);
        
        const toggleClone = toggle.cloneNode(true);
        toggle.parentNode.replaceChild(toggleClone, toggle);
        
        toggleClone.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleAccordion(this);
        });
      }
    });
  };

  const resetNestedToggles = () => {
    document.querySelectorAll('.mega-menu__link--toggle').forEach((toggle) => {
      closeNestedToggle(toggle, false);
    });
  };

  const megaMenuDetails = document.getElementById('Details-HeaderMenu-Main');
  if (megaMenuDetails && megaMenuDetails.getAttribute('data-nested-reset-bound') !== 'true') {
    megaMenuDetails.setAttribute('data-nested-reset-bound', 'true');
    megaMenuDetails.addEventListener('toggle', () => {
      if (!megaMenuDetails.open) resetNestedToggles();
    });
  }
  
  // Initial setup
  updateParentLinks();
  setupParentWrappers();
  
  window.removeEventListener('resize', updateParentLinks);
  window.removeEventListener('resize', setupParentWrappers);
  window.removeEventListener('resize', setInitialAriaLabels);
  
  window.addEventListener('resize', debounce(() => {
    updateParentLinks();
    setupParentWrappers();
    setInitialAriaLabels();
  }, 250));
};
  
const adjustMegaMenuAccordion = () => {
  const isMobile = window.innerWidth < 990;
  const submenuLists = document.querySelectorAll('.mega-menu__sublist');
  const sections = document.querySelectorAll('.mega-menu__section');
  const megaMenuContent = document.getElementById('MegaMenu-Content-Main');
  
  // Mobile: scroll the green panel; keep slime fixed below it
  if (megaMenuContent) {
    if (isMobile) {
      megaMenuContent.style.height = 'calc(100dvh - 48px)';
      megaMenuContent.style.maxHeight = 'calc(100dvh - 48px)';
      megaMenuContent.style.overflowY = 'hidden';
      const scrollPanel = megaMenuContent.querySelector('.mega-menu__scroll');
      if (scrollPanel) {
        scrollPanel.style.overflowY = 'auto';
        scrollPanel.style.webkitOverflowScrolling = 'touch';
      }
    } else {
      megaMenuContent.style.removeProperty('height');
      megaMenuContent.style.removeProperty('max-height');
      megaMenuContent.style.removeProperty('overflow-y');
      const scrollPanel = megaMenuContent.querySelector('.mega-menu__scroll');
      if (scrollPanel) {
        scrollPanel.style.removeProperty('overflow-y');
        scrollPanel.style.removeProperty('-webkit-overflow-scrolling');
      }
    }
  }
  
  if (isMobile) {
    // Mobile: All submenus hidden by default
    submenuLists.forEach(submenu => {
      submenu.style.display = 'none';
      submenu.style.maxHeight = null; // Reset max height
    });
    
    // Reset accordion toggles
    const accordionToggles = document.querySelectorAll('.mega-menu__accordion-toggle');
    accordionToggles.forEach(toggle => {
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    
    sections.forEach(section => {
      section.classList.remove('menu-open');
    });
    
    // Arrange single items in two columns
    const singleSections = document.querySelectorAll('.mega-menu__section--single');
    singleSections.forEach((section) => {
      section.style.width = '50%';
      section.style.float = 'left';
    });
    
    // Show first menu section by default
    setTimeout(() => {
      const firstSectionWithSubmenu = document.querySelector('.mega-menu__section:not(.mega-menu__section--single)');
      if (firstSectionWithSubmenu) {
        const firstToggle = firstSectionWithSubmenu.querySelector('.mega-menu__accordion-toggle');
        if (firstToggle) {
          firstToggle.setAttribute('aria-expanded', 'true');
          
          const parentLink = firstToggle.closest('.mega-menu__parent-wrapper')?.querySelector('.mega-menu__link--parent');
          const menuName = parentLink ? parentLink.textContent.trim() : 'menu';
          firstToggle.setAttribute('aria-label', `Close ${menuName} menu`);
          
          firstSectionWithSubmenu.classList.add('menu-open');
          
          const firstSubmenuId = firstToggle.getAttribute('aria-controls');
          const firstSubmenu = firstSubmenuId ? document.getElementById(firstSubmenuId) : null;
          
          if (firstSubmenu) {
            firstSubmenu.style.display = 'block';
            firstSubmenu.style.overflow = 'hidden';
            firstSubmenu.style.maxHeight = 'none';
            const targetHeight = firstSubmenu.scrollHeight;
            firstSubmenu.style.maxHeight = '0px';
            void firstSubmenu.offsetHeight;
            firstSubmenu.style.maxHeight = `${Math.max(targetHeight, 1)}px`;
            window.setTimeout(() => {
              if (firstSectionWithSubmenu.classList.contains('menu-open')) {
                firstSubmenu.style.maxHeight = 'none';
                firstSubmenu.style.overflow = 'visible';
              }
            }, 300);
          }
        }
      }
    }, 100);
  } else {
    // Desktop: Show all submenus
    submenuLists.forEach(submenu => {
      submenu.style.display = 'block';
      submenu.style.removeProperty('max-height');
    });
    
    const accordionToggles = document.querySelectorAll('.mega-menu__accordion-toggle');
    accordionToggles.forEach(toggle => {
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    });
    
    // Add menu-open class to all sections with submenus
    const sectionsWithSubmenus = document.querySelectorAll('.mega-menu__section:not(.mega-menu__section--single)');
    sectionsWithSubmenus.forEach(section => {
      section.classList.add('menu-open');
    });
    
    // Reset single items layout
    const singleSections = document.querySelectorAll('.mega-menu__section--single');
    singleSections.forEach((section) => {
      section.style.width = '';
      section.style.float = '';
    });
  }
};

class SeparatedList extends HTMLElement {
    constructor() {
        super();
        const that = this;
        window.resize(() => {
            const items = that.querySelectorAll('li');
            items.forEach((item, itemIndex) => {
                const previousItem = items[itemIndex - 1];
                const nextItem = items[itemIndex + 1];
                item.classList.toggle('first-of-row', !previousItem || item.offsetTop !== previousItem.offsetTop);
                item.classList.toggle('last-of-row', !nextItem || item.offsetTop !== nextItem.offsetTop);
            });
        });
    }
}
customElements.define('separated-list', SeparatedList);

window.onload = () => {
    init();
};




const initMegaMenu = () => {
  const megaMenuContent = document.getElementById('MegaMenu-Content-Main');
  const megaMenuDetails = document.getElementById('Details-HeaderMenu-Main');
  
  const mobileMegaMenuToggle = document.querySelector('.mobile-mega-menu-toggle');
  
  const isMobile = () => window.innerWidth < 990;
  
  if (!megaMenuContent || !megaMenuDetails) return;
  
  if (!megaMenuContent.querySelector('.mega-menu__close')) {
    const closeButton = document.createElement('button');
    closeButton.classList.add('mega-menu__close');
    closeButton.setAttribute('aria-label', 'Close menu');
    closeButton.setAttribute('aria-controls', 'MegaMenu-Content-Main');
    closeButton.innerHTML = '<span><svg xmlns="http://www.w3.org/2000/svg" fill="" class="icon icon-close" viewBox="0 0 18 17"><path fill="" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg></span>';
    megaMenuContent.appendChild(closeButton);
  }
  
  const closeButton = megaMenuContent.querySelector('.mega-menu__close');
  closeButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    closeMegaMenu(true);
  });
  
  setupMegaMenuAccordion();
  adjustMegaMenuAccordion();

  // Handle mobile menu toggle button (hamburger icon)
  if (mobileMegaMenuToggle) {
    // Remove any existing event listeners by replacing the element
    const newMobileToggle = mobileMegaMenuToggle.cloneNode(true);
    mobileMegaMenuToggle.parentNode.replaceChild(newMobileToggle, mobileMegaMenuToggle);
    
    // Set initial state
    newMobileToggle.setAttribute('aria-expanded', megaMenuDetails.hasAttribute('open') ? 'true' : 'false');
    newMobileToggle.setAttribute('aria-controls', 'MegaMenu-Content-Main');
    
    newMobileToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (megaMenuDetails.hasAttribute('open')) {
        closeMegaMenu(true);
      } else {
        openMegaMenu();
      }
    });
  }
  
  const toxicMenuButton = document.querySelector('.toxic-menu-button');
  if (toxicMenuButton) {
    // Modify the toxic menu button's attributes to make it function as a home link on mobile
    const updateToxicButtonAttributes = () => {
      if (isMobile()) {
        // On mobile, toxic menu button acts as a pure home link, not a menu button
        toxicMenuButton.setAttribute('aria-label', 'Toxic Waste Brand');
        toxicMenuButton.removeAttribute('aria-expanded');
        toxicMenuButton.removeAttribute('aria-controls');
        toxicMenuButton.removeAttribute('aria-haspopup');
        toxicMenuButton.setAttribute('role', 'link');
      } else {
        // On desktop, it should function as a menu button
        toxicMenuButton.setAttribute('aria-label', 'Menu');
        toxicMenuButton.setAttribute('aria-expanded', megaMenuDetails.hasAttribute('open') ? 'true' : 'false');
        toxicMenuButton.setAttribute('aria-controls', 'MegaMenu-Content-Main');
        toxicMenuButton.setAttribute('aria-haspopup', 'true');
        toxicMenuButton.removeAttribute('role');
      }
    };
    
    // Initial setup
    updateToxicButtonAttributes();
    
    // Update on resize
    window.addEventListener('resize', updateToxicButtonAttributes);
    
    // Create click handler
    const handleToxicButtonClick = function(e) {
      if (isMobile()) {
        // On mobile, navigate home and don't toggle menu
        e.preventDefault();
        window.location.href = '/';
      } else {
        // On desktop, toggle menu
        e.preventDefault();
        e.stopPropagation();
        
        if (megaMenuDetails.hasAttribute('open')) {
          closeMegaMenu();
        } else {
          openMegaMenu();
        }
      }
    };
    
    // Replace the button to remove any existing listeners
    const newButton = toxicMenuButton.cloneNode(true);
    toxicMenuButton.parentNode.replaceChild(newButton, toxicMenuButton);
    newButton.addEventListener('click', handleToxicButtonClick);
  }
  
  // Handle escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && megaMenuDetails.hasAttribute('open')) {
      closeMegaMenu(true);
    }
  });

  document.addEventListener('click', function(e) {
    const megaMenuDetails = document.getElementById('Details-HeaderMenu-Main');
    const megaMenuContent = document.getElementById('MegaMenu-Content-Main');
    
    const isMenuOpen = (megaMenuDetails && megaMenuDetails.hasAttribute('open')) || 
                       document.documentElement.style.overflow === 'hidden' || 
                       document.body.style.overflow === 'hidden';
    
    if (isMenuOpen) {
      if (megaMenuContent && 
          !megaMenuContent.contains(e.target) && 
          !e.target.closest('.toxic-menu-button') && 
          !e.target.closest('.mobile-mega-menu-toggle')) {
        
        closeMegaMenu(true);
      }
    }
  })
  
  // Handle window resize
  window.addEventListener('resize', () => {
    if (megaMenuDetails.hasAttribute('open') && window.innerWidth < 750) {
      closeMegaMenu();
    }
    adjustMegaMenuAccordion();
  });
  
  initFixedMenuButton();
};

window.openMegaMenu = function() {
  const megaMenuDetails = document.getElementById('Details-HeaderMenu-Main');
  const megaMenuContent = document.getElementById('MegaMenu-Content-Main');
  
  if (!megaMenuDetails || !megaMenuContent) return;
  
  // Prevent page scrolling when menu is open
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  
  megaMenuDetails.setAttribute('open', '');
  
  // Force reflow to ensure animation runs
  void megaMenuContent.offsetWidth;
  
  megaMenuDetails.classList.remove('closing');
  
  // Reset fixed state first
  megaMenuContent.classList.remove('mega-menu-fixed');
  
  // Set proper aria attributes for accessibility
  megaMenuContent.removeAttribute('aria-labelledby');
  megaMenuContent.setAttribute('aria-label', 'Main Menu');
  
  // Update mobile hamburger button state when opening menu
  const mobileToggle = document.querySelector('.mobile-mega-menu-toggle');
  if (mobileToggle) {
    mobileToggle.setAttribute('aria-expanded', 'true');
  }
  
  // Find close button and move focus to it immediately
  const closeButton = megaMenuContent.querySelector('.mega-menu__close');
  if (closeButton) {
    // Use setTimeout to ensure focus happens after the menu is visually open
    setTimeout(() => {
      closeButton.focus();
    }, 10);
  } else {
    // Fallback - move focus to the menu content if close button not found
    megaMenuContent.focus();
  }
  
// Handle mobile view
if (window.innerWidth < 990) {
  megaMenuContent.classList.add('mega-menu-mobile-open');
  
  // Update mobile toggle button state
  const mobileToggle = document.querySelector('.mobile-mega-menu-toggle');
  if (mobileToggle) {
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileToggle.classList.add('is-active');
  }
  
  // Open the first accordion section by default on mobile
  setTimeout(() => {
    const firstSectionWithSubmenu = document.querySelector('.mega-menu__section:not(.mega-menu__section--single)');
    if (firstSectionWithSubmenu) {
      const firstToggle = firstSectionWithSubmenu.querySelector('.mega-menu__accordion-toggle');
      if (firstToggle) {
        firstToggle.setAttribute('aria-expanded', 'true');
        const parentLink = firstToggle.closest('.mega-menu__parent-wrapper')?.querySelector('.mega-menu__link--parent');
        const menuName = parentLink ? parentLink.textContent.trim() : 'menu';
        firstToggle.setAttribute('aria-label', `Close ${menuName} menu`);
        
        firstSectionWithSubmenu.classList.add('menu-open');
        
        const firstSubmenuId = firstToggle.getAttribute('aria-controls');
        const firstSubmenu = firstSubmenuId ? document.getElementById(firstSubmenuId) : null;
        
        if (firstSubmenu) {
          firstSubmenu.style.display = 'block';
          firstSubmenu.style.overflow = 'hidden';
          firstSubmenu.style.maxHeight = 'none';
          const targetHeight = firstSubmenu.scrollHeight;
          firstSubmenu.style.maxHeight = '0px';
          void firstSubmenu.offsetHeight;
          firstSubmenu.style.maxHeight = `${Math.max(targetHeight, 1)}px`;
          window.setTimeout(() => {
            if (firstSectionWithSubmenu.classList.contains('menu-open')) {
              firstSubmenu.style.maxHeight = 'none';
              firstSubmenu.style.overflow = 'visible';
            }
          }, 300);
        }
      }
    }
  }, 100);
} else {
  // Desktop view - ensure all submenus are visible
  const submenuLists = document.querySelectorAll('.mega-menu__sublist');
  submenuLists.forEach(submenu => {
    submenu.style.display = 'block';
    submenu.style.removeProperty('max-height');
  });
  
  // Make sure all accordion toggles are in expanded state
  const accordionToggles = document.querySelectorAll('.mega-menu__accordion-toggle');
  accordionToggles.forEach(toggle => {
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
      
      // Update aria-label to match expanded state
      const parentLink = toggle.closest('.mega-menu__parent-wrapper')?.querySelector('.mega-menu__link--parent');
      const menuName = parentLink ? parentLink.textContent.trim() : 'menu';
      toggle.setAttribute('aria-label', `Close ${menuName} menu`);
    }
  });
  
  // Ensure all sections with submenus have the menu-open class
  const sectionsWithSubmenus = document.querySelectorAll('.mega-menu__section:not(.mega-menu__section--single)');
  sectionsWithSubmenus.forEach(section => {
    section.classList.add('menu-open');
  });
}
  
  const headerHeight = document.querySelector('.header-wrapper')?.offsetHeight || 150;
  if (window.scrollY > headerHeight && window.innerWidth >= 990) {
    setTimeout(() => {
      megaMenuContent.classList.add('mega-menu-fixed');
    }, 50);
  }
};

window.closeMegaMenu = function(focusToMobileToggle = false) {
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
  
  const megaMenuDetails = document.getElementById('Details-HeaderMenu-Main');
  const megaMenuContent = document.getElementById('MegaMenu-Content-Main');
  const menuButton = document.getElementById('HeaderMenu-main');
  
  if (!megaMenuDetails || !megaMenuContent || !megaMenuDetails.hasAttribute('open')) return;
  
  megaMenuDetails.classList.add('closing');
  
  // Reset mobile toggle button state
  const mobileToggle = document.querySelector('.mobile-mega-menu-toggle');
  if (mobileToggle) {
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.classList.remove('is-active');
  }
  
  // Remove mobile open class
  megaMenuContent.classList.remove('mega-menu-mobile-open');
  
  setTimeout(() => {
    if (megaMenuDetails.classList.contains('closing')) {
      megaMenuDetails.removeAttribute('open');
      megaMenuDetails.classList.remove('closing');
      
      // Critical part: Focus management
      if (window.innerWidth < 990) {
        // On mobile, focus should return to the hamburger button
        if (mobileToggle) mobileToggle.focus();
      } else {
        // On desktop, focus should return to the logo/menu button
        if (menuButton) menuButton.focus();
      }
    }
    
    megaMenuContent.classList.remove('mega-menu-fixed');
    
    // Close all accordions when closing the menu on mobile
    if (window.innerWidth < 990) {
      const accordionToggles = megaMenuContent.querySelectorAll('.mega-menu__accordion-toggle');
      accordionToggles.forEach(toggle => {
        const submenuId = toggle.getAttribute('aria-controls');
        const submenu = document.getElementById(submenuId);
        if (submenu && toggle.getAttribute('aria-expanded') === 'true') {
          toggle.setAttribute('aria-expanded', 'false');
          
          const parentLink = toggle.closest('.mega-menu__parent-wrapper')?.querySelector('.mega-menu__link--parent');
          const menuName = parentLink ? parentLink.textContent.trim() : 'menu';
          toggle.setAttribute('aria-label', `Open ${menuName} menu`);
          
          toggle.closest('.mega-menu__section').classList.remove('menu-open');
          
          submenu.style.removeProperty('max-height');
          submenu.style.display = 'none';
        }
      });
    }
  }, 400);
};

// Fixed menu button implementation
function initFixedMenuButton() {
  // Find the original button
  const originalButton = document.querySelector('.toxic-menu-button');
  const megaMenuDetails = document.getElementById('Details-HeaderMenu-Main');
  
  if (!originalButton || !megaMenuDetails) return;
  
  // Create the clone if it doesn't exist already
  let clone = document.querySelector('.toxic-menu-button-clone');
  
  if (!clone) {
    clone = document.createElement('button');
    clone.classList.add('toxic-menu-button-clone');
    
    const buttonContainer = originalButton.querySelector('.toxic-button-container');
    if (buttonContainer) {
      clone.innerHTML = buttonContainer.outerHTML;
    } else {
      // Fall back to copying the entire button content
      clone.innerHTML = originalButton.innerHTML;
    }
    
    // Add the clone to the body
    document.body.appendChild(clone);
  }
  
  // Get header height for scroll detection
  const headerHeight = document.querySelector('.header-wrapper')?.offsetHeight || 150;
  
  // Handle click on clone
  clone.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Check if the menu is already open
    if (megaMenuDetails.hasAttribute('open')) {
      window.closeMegaMenu();
    } else {
      window.openMegaMenu();
    }
  });
  
  // Handle scroll event
  window.addEventListener('scroll', function() {
    const megaMenuContent = document.getElementById('MegaMenu-Content-Main');
    if (!megaMenuContent) return;
    
    // Show clone when scrolled past the header
    if (window.scrollY > headerHeight - 50 && window.innerWidth >= 990) {
      clone.classList.add('active');
    } else {
      clone.classList.remove('active');
    }
    
    if (megaMenuDetails.hasAttribute('open')) {
      if (window.scrollY > headerHeight && window.innerWidth >= 990) {
        megaMenuContent.classList.add('mega-menu-fixed');
      } else {
        megaMenuContent.classList.remove('mega-menu-fixed');
      }
    }
  });
}